// Admin theme: light/dark, persisted, applied to <html data-theme> so portaled
// modals/toasts inherit it too. Dark is the default.
const KEY = 'jg-admin-theme';

export const getTheme = () => {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; }
  catch { return 'dark'; }
};

export const applyTheme = (t) => {
  if (typeof document !== 'undefined') document.documentElement.dataset.theme = t;
};

export const setTheme = (t) => {
  try { localStorage.setItem(KEY, t); } catch {}
  applyTheme(t);
};

export const initTheme = () => applyTheme(getTheme());

export const toggleTheme = () => {
  const next = getTheme() === 'light' ? 'dark' : 'light';
  setTheme(next);
  return next;
};
